import React from 'react';

/**
 * Step progress bar for the onboarding wizard.
 * Shows step names with filled/active/upcoming states.
 */
export default function OnboardingProgressBar({ currentStep, steps }) {
  return (
    <div className="w-full px-4 pt-6 pb-2 max-w-lg mx-auto">
      {/* Step dots + connector line */}
      <div className="flex items-center">
        {steps.map((step, index) => {
          const isDone    = index < currentStep;
          const isActive  = index === currentStep;
          const isUpcoming = index > currentStep;

          return (
            <React.Fragment key={step.key}>
              {/* Connector line (before each step except first) */}
              {index > 0 && (
                <div
                  className={`flex-1 h-0.5 transition-colors duration-300
                    ${isDone ? 'bg-reset-terracotta' : 'bg-gray-200'}`}
                />
              )}

              {/* Step dot */}
              <div className="flex flex-col items-center">
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold border-2 transition-all duration-300
                    ${isDone
                      ? 'bg-reset-terracotta border-reset-terracotta text-white'
                      : isActive
                        ? 'bg-white border-reset-terracotta text-reset-terracotta ring-4 ring-orange-100'
                        : 'bg-white border-gray-300 text-gray-400'
                    }`}
                >
                  {isDone ? '✓' : index + 1}
                </div>
                <span
                  className={`text-xs mt-1 font-medium hidden sm:block transition-colors
                    ${isActive ? 'text-reset-terracotta' : isDone ? 'text-gray-500' : 'text-gray-300'}`}
                >
                  {step.label}
                </span>
              </div>
            </React.Fragment>
          );
        })}
      </div>

      {/* Mobile: current step name only */}
      <p className="text-center text-xs text-reset-terracotta font-medium mt-2 sm:hidden">
        Step {currentStep + 1} of {steps.length}: {steps[currentStep]?.label}
      </p>
    </div>
  );
}
